import cleanApiClient from '../clienteAPI';
import apiClient from '../clienteFebosAPI';

const RESOURCE = '/herramientas';

export const ioValidacionQr = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}/validacion/qr?${params}`, { operacionId: 'cl.verificar.qr' });
};

export const ioListConfigurations = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`/v2/configuraciones?${params}`,
    { operacionId: 'io.listar.configuraciones', permiso: 'ADM30' });
};

/**
 * @description Get parameter config from parameter id.
 * @param id {string} Parameter id.
 * @returns {Promise}
 */
export const ioGetConfiguration = async (id) => {
  const params = apiClient.queryParams({ parametros: id });
  const {
    data: {
      configuraciones: {
        [id]: {
          nombre: name,
          valorGlobal: valueGlobal,
          valorEmpresa: valueCompany,
          valorPortal: valuePortal,
          valorUsuario: valueUser
        }
      }
    }
  } = await apiClient.get(`/v2/configuraciones?${params}`,
    { operacionId: 'io.obtener.configuracion', permiso: 'ADM30' });
  return {
    id,
    name,
    value: valueUser || valuePortal || valueCompany || valueGlobal
  };
};

export const ioGetParameter = async ({ parametro, parametros, detailed = false }) => {
  const params = apiClient.queryParams({ parametro, parametros, detailed });
  const { data } = await apiClient.get(`/v2/herramientas/parametros/?${params}`,
    { operacionId: 'io.obtener.configuracion', permiso: 'ADM30' });
  return data;
};

export const ioListOptions = (payload = { grupoOpcion: null, filtros: '' }) => {
  const params = apiClient.queryParamsComponent(payload);
  return apiClient.get(`/v2/herramientas/opciones?${params}`,
    { operacionId: 'io.opciones.listar', permiso: 'WOP01' });
};

export const ioSaveOption = (param, data = {}) => {
  const params = apiClient.queryParams(param);
  return apiClient.post(`/v2/herramientas/opciones?${params}`, data,
    { operacionId: 'io.opciones.save', permiso: 'WOP01' });
};

export const ioMigrateOption = (
  param = { global: 'no', id: '' },
  data = { destinos: [] }
) => {
  const params = apiClient.queryParams(param);
  return apiClient.post(`/v2/herramientas/opciones/migrar?${params}`, data,
    { operacionId: 'io.opciones.migrate', permiso: 'WOP01' });
};

export const ioMigrateConfiguration = ({
  parameter, level, ambients, app, usuarioId
}) => apiClient.put('/configuracion/configuraciones',
  {
    parametros: [parameter],
    nivel: level,
    ambientes: ambients,
    app,
    usuarioId
  },
  {
    operacionId: 'io.migrar.configuraciones',
    permiso: 'ADM31'
  });

export const ioMigrateConfigurations = (
  {
    parameter = [],
    level,
    ambients,
    app,
    usuarioId
  }
) => apiClient.put('/configuracion/configuraciones',
  {
    parametros: parameter,
    nivel: level,
    ambientes: ambients,
    app,
    usuarioId
  },
  {
    operacionId: 'io.migrar.configuraciones',
    permiso: 'ADM31'
  });
export const ioSaveParameter = (requestParams, payload) => {
  const params = apiClient.queryParams(requestParams);
  return apiClient.post(`/v2/herramientas/parametros/?${params}`, { configuraciones: [payload] },
    { operacionId: 'io.guardar.configuraciones', permiso: 'ADM31' });
};
export const ioSaveConfiguration = (requestParams, payload) => {
  const params = apiClient.queryParams(requestParams);
  return apiClient.post(`/configuracion/configuraciones?${params}`, { configuraciones: [payload] },
    { operacionId: 'io.guardar.configuraciones', permiso: 'ADM31' });
};
export const ioSaveConfigurations = (requestParams, payload) => {
  const params = apiClient.queryParams(requestParams);
  return apiClient.post(`/configuracion/configuraciones?${params}`, { configuraciones: payload },
    { operacionId: 'io.guardar.configuraciones', permiso: 'ADM31' });
};

export const ioDownloadPrivateFile = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}/archivos/privados?${params}`,
    { operacionId: 'cl.download.file' });
};

export const ioDownloadContentPrivateFile = async (url) => {
  const response = await ioDownloadPrivateFile({ path: url });
  const responseText = await fetch(response.data.url);
  const text = await responseText.text();
  return text;
};

export const ioGetPrivateUploadUrl = (fileUrl, fileMime) => {
  const params = apiClient.queryParams({
    tipo: 'upload',
    key: fileUrl,
    contentType: fileMime
  });
  return apiClient.get(
    `${RESOURCE}/archivos?${params}`, { operacionId: 'cl.tools.private-url.file' }
  );
};

export const ioGetPrivateMultipartUploadUrl = ({
  file,
  uploadId,
  abort = false,
  headers = {},
  parts = 1,
  tags = []
}) => apiClient.post(
  '/v2/herramientas/adjunto/pre-signed/multipart',
  {
    file,
    abort,
    uploadId,
    headers,
    parts,
    tags
  },
  { operacionId: 'cl.tools.private-multipart-url.file' }
);

export const ioUploadFileToPrivateUrl = (url, file, progressCallback) => cleanApiClient.put(
  url,
  file,
  {
    headers: {
      Vary: 'Access-Control-Request-Headers, Access-Control-Request-Method, Origin'
    },
    onUploadProgress: (progressEvent) => {
      const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      progressCallback(percent);
    }
  }
);

export const ioExtraDataListar = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(
    `${RESOURCE}/extradata?${params}`, { operacionId: 'io.get.extradata' }
  );
};

export const ioExtraDataGuardar = (payload) => apiClient.post(
  `${RESOURCE}/extradata?`, payload, { operacionId: 'io.post.extradata' }
);

export const oiDivisionPolitica = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(
    `/v2/herramientas/divisionpolitica?${params}`,
    { operacionId: 'io.division.politica.listar' }
  );
};

export const openText = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.post(
    `${RESOURCE}/externos/opentext/?${params}`,
    payload.data,
    { operacionId: 'io.post.openText' }
  );
};

export const idVersionOpenText = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.post(
    `${RESOURCE}/externos/opentext/?${params}`,
    {},
    { operacionId: 'io.post.idVersionOpenText' }
  );
};

export const linkOpenText = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.post(
    `${RESOURCE}/externos/opentext/?${params}`,
    {},
    { operacionId: 'io.post.linkOpenText' }
  );
};

export const ioMassiveProcess = ({
  accion,
  nombre,
  comunes = {},
  payload = [],
  metodo = 'SERIE'
}) => apiClient.post(`${RESOURCE}/masivas`,
  {
    accion,
    nombre,
    comunes,
    payload,
    metodo
  }, { operacionId: 'io.massive.process' });

export const ioListRateOfExchange = ({
  iut,
  fecha,
  pagina = 1,
  itemsPorPagina = 1000
} = {}) => {
  const params = apiClient.queryParamsComponent({
    iut,
    fecha,
    pagina,
    itemsPorPagina
  });
  return apiClient.get(`/configuracion/monedas/tasas?${params}`,
    { operacionId: 'io.configuraciones.tasa.cambio.listar', permiso: 'CFG01' });
};
export const queueTask = (requestParams, task) => {
  const params = apiClient.queryParams(requestParams);
  return apiClient.post(`${RESOURCE}/tareas?${params}`, { payload: task }, { operacionId: 'io.encolar.tarea.background' });
};
export const verifyQueueTask = (taskId) => apiClient.get(`${RESOURCE}/tareas/${taskId}`, { operacionId: 'io.verificar.tarea.background' });
